import React, { FC, memo } from 'react';

import { TEXTS } from 'application/pages/texts';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

interface SuccessActionButtonProps {
  showWebPlayerButton: boolean;
  onShowWebPlayerClick: () => void;
  onShowPointsPage: () => void;
}

const SuccessActionButton: FC<SuccessActionButtonProps> = ({
  showWebPlayerButton,
  onShowWebPlayerClick,
  onShowPointsPage,
}) => {
  if (showWebPlayerButton) {
    return (
      <Button
        elementId="button_open_web_player_bind_success_modal"
        type={ButtonType.PRIMARY}
        onClick={onShowWebPlayerClick}>
        {TEXTS.MODAL_BIND_SUCCESS_BUTTON_OPEN_WEB_PLAYER_TEXT}
      </Button>
    );
  }

  return (
    <Button
      elementId="button_open_points_bind_success_modal"
      type={ButtonType.PRIMARY}
      onClick={onShowPointsPage}>
      {TEXTS.MODAL_BIND_SUCCESS_BUTTON_OPEN_POINTS_TEXT}
    </Button>
  );
};

export default memo(SuccessActionButton);
